import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { Box, Button, Typography, useMediaQuery } from '@frontierag/frontier-ui-library';
import { PageLayout } from 'components';

import { styles } from './styles';

export default function NotFound() {
  const { t } = useTranslation('NotFound');
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));

  return (
    <PageLayout>
      <Box
        position="absolute"
        left={0}
        right={0}
        top="50%"
        mt={'-140px'}
        sx={isMobile ? styles.containerMobile : {}}
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          rowGap={3}
        >
          <Box display="flex" justifyContent="center">
            <Typography
              textAlign="center"
              variant="subtitle2"
              color="primary"
              sx={{ fontSize: 90 }}
              mb={2}
            >
              404
            </Typography>
          </Box>
          <Box textAlign="center">
            <Typography variant="subtitle1">{t('title')}</Typography>
          </Box>
          <Box maxWidth={400} textAlign="center">
            <Typography variant="subtitle3">{t('subtitle')}</Typography>
          </Box>
          <Box maxWidth={400}>
            <Button variant="contained" component={Link} to="/" fullWidth={false}>
              {t('goBackButton')}
            </Button>
          </Box>
        </Box>
      </Box>
    </PageLayout>
  );
}
